export enum ActionsColor {
  BLUE = 'blue',
  GREEN = 'green',
  ORANGE = 'orange',
  PURPLE = 'purple',
}

export const LAYOUT_NAME_HINT_MAX_LENGTH = 24;
